import { render, staticRenderFns } from "./attr-output-radio.vue?vue&type=template&id=3c5d74fd&scoped=true&"
import script from "./attr-output-radio.vue?vue&type=script&lang=ts&"
export * from "./attr-output-radio.vue?vue&type=script&lang=ts&"
import style0 from "./attr-output-radio.vue?vue&type=style&index=0&id=3c5d74fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d74fd",
  null
  
)

export default component.exports